import DefaultLandingNavbar from 'components/navbars/default-landing-navbar/DefaultLandingNavbar';
import HeroHeader from 'components/modules/landing/default/HeroHeader';
import FeaturesLaboral from 'components/modules/landing/default/features/FeaturesLaboral';
import OtrasEspecialidades from 'components/modules/landing/default/blog/Blog'; // Usamos el componente Blog adaptado
import Testimonial from 'components/modules/landing/default/testimonial/Testimonial';
import PorQueNosotros from 'components/modules/landing/default/fun-facts/FunFacts'; // Usamos FunFacts adaptado
import AddressSection from 'components/modules/landing/default/address/AddressSection'; // Contiene Ubicación, FAQ y Contacto
import Cta from 'components/modules/landing/default/Cta'; // Dejanos tu opinión
import Footer from 'components/modules/landing/default/Footer';
import useSettingsMountEffect from 'hooks/useSettingsMountEffect';

const Default = () => {
  useSettingsMountEffect({
    disableNavigationType: true,
    disableHorizontalNavbarAppearance: true,
    disableVerticalNavbarAppearance: true,
    disableHorizontalNavbarShape: true
  });

  return (
    <div className="bg-body-emphasis">
      <DefaultLandingNavbar />
      <HeroHeader />
      <FeaturesLaboral />
      <OtrasEspecialidades />
      <Testimonial />
      <Cta />
      <PorQueNosotros />
      <AddressSection />
      <Footer />
    </div>
  );
};

export default Default;